import React from 'react';
import FullScreenManager from './src/components/Context/FullScreenManager';
import ChatManager from './src/components/modules/Yamb/components/Chat/ChatManager';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => (
	<ChatManager>
		<FullScreenManager>
			{element}
		</FullScreenManager>
	</ChatManager>
);
